<form class="generate-contract-dialog" [formGroup]="contractFG" (ngSubmit)="generateContract()">
    <button mat-icon-button type="button" class="close-dialog-button" (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
    </button>
    <span class="dialog-title">
        Contrato de garantía
    </span>
    <span class="dialog-description">
        Aquí podrá generar el contrato de garantía que luego será enviado por mail al inquilino, por favor verifique que
        los datos de la garantía estén actualizados.
    </span>
    <div class="section-title-container" (click)="showSection.general = !showSection.general"
        [ngClass]="{ open: showSection.general }">
        <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
        <span class="section-title">Información del contrato</span>
    </div>
    <div class="section" [ngClass]="{ show: showSection.general }">
        <mat-radio-group class="form-radio-line" formControlName="firmaPresencial" color="primary">
            <span class="radio-line-label">
                Tipo de firma
            </span>
            <div class="radios">
                <mat-radio-button [value]="true">Firma en persona</mat-radio-button>
                <!-- TODO Activar firma digital cuando corresponda -->
                <mat-radio-button [value]="false" [disabled]="true">Firma digital</mat-radio-button>
            </div>
        </mat-radio-group>
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Fecha de firma</mat-label>
                <input matInput formControlName="fechaFirma" [matDatepicker]="picker1">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error *ngIf="contractFG.controls['fechaFirma'].hasError('required')">
                    Por favor seleccione la fecha
                </mat-error>
                <mat-error *ngIf="contractFG.controls['fechaFirma'].hasError('matDatepickerMin')">
                    Debe ser posterior al día de hoy
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Ciudad de firma</mat-label>
                <input matInput formControlName="ciudadFirma">
                <mat-error *ngIf="contractFG.controls['ciudadFirma'].hasError('required')">
                    Por favor seleccione la ciudad donde se firmará
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Inicio de alquiler</mat-label>
                <input matInput formControlName="fechaInicioAlquiler" [matDatepicker]="picker2">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-error *ngIf="contractFG.controls['fechaInicioAlquiler'].hasError('required')">
                    Por favor seleccione la fecha
                </mat-error>
                <mat-error *ngIf="contractFG.controls['fechaInicioAlquiler'].hasError('matDatepickerMin')">
                    Debe ser posterior al día de hoy
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Fin de alquiler</mat-label>
                <input matInput formControlName="fechaFinAlquiler" [matDatepicker]="picker3">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
                <mat-error *ngIf="contractFG.controls['fechaFinAlquiler'].hasError('required')">
                    Por favor seleccione la fecha
                </mat-error>
                <mat-error *ngIf="contractFG.controls['fechaFinAlquiler'].hasError('matDatepickerMin')">
                    Debe ser posterior al día de hoy
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="section-title-container" (click)="showSection.propiedad = !showSection.propiedad"
        [ngClass]="{ open: showSection.propiedad }">
        <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
        <span class="section-title">Datos de la propiedad</span>
    </div>
    <form class="section property-section" [formGroup]="direccionFG" [ngClass]="{ show: showSection.propiedad }">
        <app-address-form [formGroup]="direccionFG" [provinces]="data.provinces"></app-address-form>
    </form>
    <div class="section-title-container" (click)="showSection.alquiler = !showSection.alquiler"
        [ngClass]="{ open: showSection.alquiler }">
        <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
        <span class="section-title">Datos del alquiler</span>
    </div>
    <div class="section quote-section" [ngClass]="{ show: showSection.alquiler }">
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Alquiler</mat-label>
                <input matInput formControlName="alquiler" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-error *ngIf="contractFG.controls['alquiler'].hasError('required')">
                    Por favor ingrese el alquiler
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Expensas</mat-label>
                <input matInput formControlName="expensas" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-error *ngIf="contractFG.controls['expensas'].hasError('required')">
                    Por favor ingrese las expensas
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line" *ngIf="data.warranty.cotizacion && data.warranty.cotizacion.tipo === 'COMERCIAL'">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Porcentaje de actualización</mat-label>
                <input matInput formControlName="actualizacion" type="number" style="text-align: right;">
                <span matSuffix>&nbsp; %</span>
                <mat-error *ngIf="contractFG.controls['actualizacion'].hasError('required')">
                    Por favor ingrese el porcentaje de actualización
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Periodo de actualización</mat-label>
                <mat-select formControlName="periodoActualizacion">
                    <mat-option *ngFor="let period of updatePeriods" [value]="period.codigo">
                        {{ period.descripcion }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="contractFG.controls['periodoActualizacion'].hasError('required')">
                    Por favor seleccione el periodo de actualización
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="section-title-container" (click)="showSection.pago = !showSection.pago"
        [ngClass]="{ open: showSection.pago }">
        <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
        <span class="section-title">Datos de pago</span>
    </div>
    <form class="section payment-section" [formGroup]="opcionPagoFG" [ngClass]="{ show: showSection.pago }">
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Cantidad de cuotas</mat-label>
                <input matInput formControlName="cuotas" type="number">
                <mat-error *ngIf="opcionPagoFG.controls['cuotas'].hasError('required')">
                    Por favor ingrese la cantidad de cuotas
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Monto por cuota</mat-label>
                <input matInput formControlName="montoPorCuota" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-error *ngIf="opcionPagoFG.controls['montoPorCuota'].hasError('required')">
                    Por favor ingrese el monto por cuota
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Monto total</mat-label>
                <input matInput formControlName="montoTotal" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-error *ngIf="opcionPagoFG.controls['montoTotal'].hasError('required')">
                    Por favor ingrese el monto total
                </mat-error>
            </mat-form-field>
        </div>
    </form>
    <div class="section-title-container" (click)="showSection.servicios = !showSection.servicios"
        [ngClass]="{ open: showSection.servicios }">
        <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
        <span class="section-title">Topes de servicios</span>
    </div>
    <div class="section services-section" [ngClass]="{ show: showSection.servicios }">
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Tope Agua y Cloacas</mat-label>
                <input matInput formControlName="topeAguaYCloacas" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-hint *ngIf="topeMaxConfig('AGUA') as max">Máx. configurado: {{ utilsService.parseByType(max, 'money') }}</mat-hint>
                <mat-error *ngIf="contractFG.controls['topeAguaYCloacas'].hasError('required')">
                    Por favor ingrese el tope de agua y cloacas
                </mat-error>
                <mat-error *ngIf="contractFG.controls['topeAguaYCloacas'].hasError('min')">
                    El valor debe ser mayor a 0
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Tope Electricidad</mat-label>
                <input matInput formControlName="topeElectricidad" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-hint *ngIf="topeMaxConfig('LUZ') as max">Máx. configurado: {{ utilsService.parseByType(max, 'money') }}</mat-hint>
                <mat-error *ngIf="contractFG.controls['topeElectricidad'].hasError('required')">
                    Por favor ingrese el tope de electricidad
                </mat-error>
                <mat-error *ngIf="contractFG.controls['topeElectricidad'].hasError('min')">
                    El valor debe ser mayor a 0
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Tope Gas</mat-label>
                <input matInput formControlName="topeGas" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-hint *ngIf="topeMaxConfig('GAS') as max">Máx. configurado: {{ utilsService.parseByType(max, 'money') }}</mat-hint>
                <mat-error *ngIf="contractFG.controls['topeGas'].hasError('required')">
                    Por favor ingrese el tope de gas
                </mat-error>
                <mat-error *ngIf="contractFG.controls['topeGas'].hasError('min')">
                    El valor debe ser mayor a 0
                </mat-error>
            </mat-form-field>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Tope ABL</mat-label>
                <input matInput formControlName="topeABL" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-hint *ngIf="topeMaxConfig('ABL') as max">Máx. configurado: {{ utilsService.parseByType(max, 'money') }}</mat-hint>
                <mat-error *ngIf="contractFG.controls['topeABL'].hasError('required')">
                    Por favor ingrese el tope de ABL
                </mat-error>
                <mat-error *ngIf="contractFG.controls['topeABL'].hasError('min')">
                    El valor debe ser mayor a 0
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-line">
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Tope Expensas Ordinarias</mat-label>
                <input matInput formControlName="expensasOrdinariasTope" type="number">
                <span matPrefix>$ &nbsp;</span>
                <mat-error *ngIf="contractFG.controls['expensasOrdinariasTope'].hasError('required')">
                    Por favor ingrese el tope de expensas ordinarias
                </mat-error>
                <mat-error *ngIf="contractFG.controls['expensasOrdinariasTope'].hasError('min')">
                    El valor debe ser mayor a 0
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="sections-container" *ngFor="let ownerFG of propietariosArrayControls; let i = index">
        <div class="section-title-container" (click)="showSection['propietario' + i] = !showSection['propietario' + i]"
            [ngClass]="{ open: showSection['propietario' + i] }">
            <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
            <span class="section-title">Datos del propietario {{ i + 1 }}</span>
        </div>
        <form class="section owner-section" [formGroup]="ownerFG" [ngClass]="{ show: showSection['propietario' + i] }">
            <app-physical-person-form [formGroup]="getPhysicalPersonFG(ownerFG)"
                [personType]="getPersonType(ownerFG)"></app-physical-person-form>
            <app-legal-person-form [formGroup]="getLegalPersonFG(ownerFG)"
                [personType]="getPersonType(ownerFG)"></app-legal-person-form>
        </form>

        <div class="section-title-container"
            (click)="showSection['direccionPropietario' + i] = !showSection['direccionPropietario' + i]"
            [ngClass]="{ open: showSection['direccionPropietario' + i] }">
            <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
            <span class="section-title">Dirección del propietario {{ i + 1 }}</span>
        </div>
        <form class="section owner-address-section" [formGroup]="getAddressFG(ownerFG)"
            [ngClass]="{ show: showSection['direccionPropietario' + i] }">
            <app-address-form [formGroup]="getAddressFG(ownerFG)" [provinces]="data.provinces"></app-address-form>
        </form>

        <div class="section-title-container"
            (click)="showSection['representantePropietario' + i] = !showSection['representantePropietario' + i]"
            [ngClass]="{ open: showSection['representantePropietario' + i] }">
            <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
            <span class="section-title">Representante del propietario {{ i + 1 }}</span>
        </div>
        <form class="section owner-representative-section" [formGroup]="getRepresentativeFG(ownerFG)"
            [ngClass]="{ show: showSection['representantePropietario' + i] }">
            <app-representative-form [formGroup]="getRepresentativeFG(ownerFG)" [personType]="getPersonType(ownerFG)"
                [provinces]="data.provinces"></app-representative-form>
        </form>
    </div>
    <div class="sections-container" *ngFor="let tenantFG of inquilinosArrayControls; let i = index">
        <div class="section-title-container" (click)="showSection['inquilino' + i] = !showSection['inquilino' + i]"
            [ngClass]="{ open: showSection['inquilino' + i] }">
            <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
            <span class="section-title">Datos del inquilino {{ i + 1 }}</span>
        </div>
        <form class="section tenant-section" [formGroup]="tenantFG" [ngClass]="{ show: showSection['inquilino' + i] }">
            <app-physical-person-form [formGroup]="getPhysicalPersonFG(tenantFG)"
                [personType]="getPersonType(tenantFG)"></app-physical-person-form>
            <app-legal-person-form [formGroup]="getLegalPersonFG(tenantFG)"
                [personType]="getPersonType(tenantFG)"></app-legal-person-form>
        </form>

        <div class="section-title-container"
            (click)="showSection['direccionInquilino' + i] = !showSection['direccionInquilino' + i]"
            [ngClass]="{ open: showSection['direccionInquilino' + i] }" *ngIf="getPersonType(tenantFG) === 'JURIDICA'">
            <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
            <span class="section-title">Dirección del inquilino {{ i + 1 }}</span>
        </div>
        <form class="section tenant-address-section" [formGroup]="getAddressFG(tenantFG)"
            [ngClass]="{ show: showSection['direccionInquilino' + i] }" *ngIf="getPersonType(tenantFG) === 'JURIDICA'">
            <app-address-form [formGroup]="getAddressFG(tenantFG)" [provinces]="data.provinces"></app-address-form>
        </form>

        <div class="section-title-container"
            (click)="showSection['representanteInquilino' + i] = !showSection['representanteInquilino' + i]"
            [ngClass]="{ open: showSection['representanteInquilino' + i] }">
            <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
            <span class="section-title">Representante del inquilino {{ i + 1 }}</span>
        </div>
        <form class="section tenant-representative-section" [formGroup]="getRepresentativeFG(tenantFG)"
            [ngClass]="{ show: showSection['representanteInquilino' + i] }">
            <app-representative-form [formGroup]="getRepresentativeFG(tenantFG)" [personType]="getPersonType(tenantFG)"
                [provinces]="data.provinces"></app-representative-form>
        </form>
    </div>
    <div class="section-title-container" (click)="showSection.firmantes = !showSection.firmantes"
    [ngClass]="{ open: showSection.firmantes }">
    <mat-icon class="section-title-arrow">keyboard_arrow_right</mat-icon>
    <span class="section-title">Firmantes del contrato</span>
</div>

<div class="section" [ngClass]="{ show: showSection.firmantes }">
    <mat-form-field class="garantor-form-field" appearance="outline">
        <mat-label>Seleccione un firmante</mat-label>
        <mat-select formControlName="firmante">
            <mat-option *ngFor="let sign of signatories" [value]="sign">
                {{ sign.nombre }} - {{ sign.cargo }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="contractFG.controls['firmante'].hasError('required')">
            Por favor seleccione un firmante
        </mat-error>
    </mat-form-field>

    <div *ngIf="contractFG.value.firmante" class="firmante-detalle">
        <p><strong>DNI:</strong> {{ contractFG.value.firmante.dni }}</p>
        <p><strong>Domicilio:</strong> {{ contractFG.value.firmante.domicilio }}</p>
        <p><strong>Email:</strong> {{ contractFG.value.firmante.email }}</p>
    </div>
</div>
    <div class="buttons">
        <button mat-button color="primary" class="garantor-button preview-button" type="button"
            (click)="openPreview('GARANTIA')">Vista previa (contrato garantía)</button>
        <button mat-raised-button color="primary" class="garantor-button generate-contract">Generar contrato</button>
    </div>
</form>